import { Component } from '@angular/core';
import { NotificationService } from 'app/services/local-services/notification-service.service';
import { CustomNotification } from 'app/utilities/types/notification';
import { NotificationComponent } from './notification/notification.component';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css'],
  imports: [NotificationComponent],
})
export class NotificationsComponent {
  notifications: CustomNotification[] = [];

  constructor(private notificationService: NotificationService) {}

  ngOnInit() {
    this.notificationService.notifications$.subscribe((data: CustomNotification[]) => {
      this.notifications = data;
    });
  }

  closeNotification(id: string) {
    this.notificationService.removeNotification(id);
  }
}
